"use strict";Object.defineProperty(exports, "__esModule", {value: true});var RouteName; (function (RouteName) {
  const search = 'search'; RouteName["search"] = search;
  const inbox = 'inbox'; RouteName["inbox"] = inbox;
  const directory = 'directory'; RouteName["directory"] = directory;
  const broadcast = 'broadcast'; RouteName["broadcast"] = broadcast;
  const forms = 'forms'; RouteName["forms"] = forms;
  const video = 'video'; RouteName["video"] = video;
  RouteName["super"] = 'super';
  const feedback = 'feedback'; RouteName["feedback"] = feedback;
  const settings = 'settings'; RouteName["settings"] = settings;
})(RouteName || (exports.RouteName = RouteName = {}));
